export default "__VITE_ASSET__JkWF8Orn__"